import { PlayerConfigurationAPI, PlayerConfigurationWithVideoCodeAPI, PlayerInitializationAPI } from "./PlayerAPI";
import { PlayerAPIImpl } from "./PlayerAPIImpl";

class PlayerInitializationAPIImpl implements PlayerInitializationAPI {

  initialize(elementId: string): PlayerConfigurationAPI;
  initialize(elementId: string, videoCode: string): PlayerConfigurationWithVideoCodeAPI;
  initialize(elementId: string, videoCode?: string): PlayerConfigurationAPI | PlayerConfigurationWithVideoCodeAPI {
    const palayerAPI = new PlayerAPIImpl(elementId, videoCode);
    if (videoCode) {
      return palayerAPI as PlayerConfigurationWithVideoCodeAPI;
    } else {
      return palayerAPI as PlayerConfigurationAPI;
    }
  }
}

export { PlayerInitializationAPIImpl as Player };
